module.exports = __webpack_public_path__ + "static/media/1-1_Instant_kafa_Korigovan_predlog_resenja.decee615.jpg";